import { createTheme } from "@mui/material/styles";

import * as colors from "config/styles/colors";
export function getTheme() {
  const fontSize = 14;
  const fontFamily = `"Kantar Brown", "Helvetica", sans-serif`;
  const blackishMain = colors.blackish;
  const whiteishMain = colors.whiteish;
  return createTheme({
    palette: {
      type: "light",
      primary: {
        main: "#802AB6",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#AA8A30",
      },
      blackish: { main: blackishMain },
      whiteish: { main: whiteishMain },
    },
    typography: {
      fontFamily,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { fontSize, fontFamily, color: whiteishMain, backgroundColor: blackishMain, height: "100%" },
          input: { fontFamily: "inherit", fontSize: "100%", lineHeight: "1.15em", margin: 0 },
          button: { fontFamily: "inherit", fontSize: "100%", lineHeight: "1.15em", margin: 5 },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
      },
    },
  });
}
